import React, { useState, useEffect, SyntheticEvent, useMemo } from 'react'
import { SiteViewModel } from '../ViewModel'

// mui
import { toast } from 'react-toastify'

import { Grid, Stack, Typography } from '@mui/material'
import SearchBar from '../../components/SearchBar/SearchBarComponent'
import { SiteTabBar, SiteTabPanel } from './components/SiteTabBar'
import SiteEventsTable from './components/SiteEventsTable'
import SiteInfoPanel from './components/SiteInfoPanel'
import ActionsPanel from './components/ActionsPanel'

import SitesTable from './SitesTable'

// servicess
import { searchSite } from '../../model'
import { useParams } from 'react-router-dom'
import { useAppNavigate } from '../../Paths'
import { useAuth } from '../Auth'
import NewSiteDialog from './components/NewSiteDialog'

const DataCollectionPage = () => {
  const [selectedSite, setSelectedSite] = useState({} as SiteViewModel | null)

  const [tabValue, setTabValue] = useState(1)

  const [searchTerm, setSearchTerm] = useState('') //for searchbar

  const { sites: sitesData } = useAuth()
  const filterSites = useMemo(() => {
    if (searchTerm.trim().length === 0) {
      return sitesData
    }

    const searchedSites = searchSite(sitesData, searchTerm)

    if (searchedSites.length === 0) {
      // toast.info('No sites found')
      return []
    }
    return searchedSites
  }, [searchTerm, sitesData.length])

  const { siteId } = useParams()
  const appNavigate = useAppNavigate()

  useEffect(() => {
    console.count('Data Collection Page Load')
    let unsubcribed = false
    if (unsubcribed) return

    //cleanup
    return () => {
      unsubcribed = true

      setSearchTerm('')
      setSelectedSite(null)
    }
  }, [])

  useEffect(() => {
    let unsubscribed = false
    if (unsubscribed) return

    if (siteId) {
      setTabValue(0)
      const site = sitesData.find((site) => site.id === siteId)
      if (site == null) {
        appNavigate.toDataCollection()
      } else {
        setSelectedSite({ ...site })
      }
    }

    return () => {
      unsubscribed = true
      setTabValue(0)
      setSelectedSite(null)
    }
  }, [siteId])

  const [newSiteModalOpen, setNewSiteModalOpen] = useState(false)

  const handleAddNewSiteClicked = () => {
    setNewSiteModalOpen(true)
  }

  const handleSelectingSite = (id: string) => {
    appNavigate.toSite(id)
  }

  const handleTabChange = (event: SyntheticEvent, newValue: number) => {
    setTabValue(newValue)
  }

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        item
        md={siteId ? 3 : 5}
        padding={1}
        alignItems="flex-start"
      >
        <Stack width="100%" spacing={2}>
          <SearchBar
            value={searchTerm}
            label="Site"
            onChangeText={(t) => setSearchTerm(t)}
            // onSearch={search}
            onAddNewSite={handleAddNewSiteClicked}
          />
          <SitesTable
            sites={filterSites}
            onSelectedSite={handleSelectingSite}
          />
        </Stack>
      </Grid>
      <Grid container item md={siteId ? 9 : 7} padding={2}>
        {siteId && (
          <Stack width="100%">
            <Stack>
              <Typography variant="h4" sx={{ color: 'black' }}>
                {selectedSite?.siteName}
              </Typography>
              <Typography variant="h5">{selectedSite?.id}</Typography>
            </Stack>

            <SiteTabBar tabValue={tabValue} handleTabChange={handleTabChange} />
            <SiteTabPanel value={tabValue} index={0}>
              <SiteInfoPanel site={selectedSite} />
            </SiteTabPanel>
            <SiteTabPanel value={tabValue} index={1}>
              {siteId ? <SiteEventsTable siteId={siteId} /> : <></>}
            </SiteTabPanel>
            <SiteTabPanel value={tabValue} index={2}>
              <ActionsPanel site={selectedSite} />
            </SiteTabPanel>
          </Stack>
        )}
      </Grid>
      <NewSiteDialog
        open={newSiteModalOpen}
        onClose={() => {
          setNewSiteModalOpen(false)
        }}
      />
    </Grid>
  )
}

export default DataCollectionPage
